// This file is used for all user related service
import config from '../../config';
import store from '../store';
import { objectToQueryParams } from '../helpers/common';
import APIService from './APIService';
/**
 *
 */
export default class UserService extends APIService {
  /**
   * Return all users
   *
   * @param {boolean} collab
   * @param {boolean} userOrg
   * @param {string} searchText
   */
  static loadUsersAll(
    collab = false,
    userOrg,
    searchText,
    params = {
      pageNumber: 1,
      pageSize: 2000,
      userStatuses: 'ACTIVE',
      sortBy: 'firstName',
      sortOrder: 'ASC',
      searchText: ''
    }
  ) {
    let searchWhat = collab ? 'listCollaborators' : 'listUsers';
    let url = `${config.baseUrlForUserOrg}/${searchWhat}/${
      userOrg ? store.state.orgId : store.state.currentlySelectedOrgId
    }?`;

    if (params) {
      url += objectToQueryParams(params);
    }
    return this.get(url);
  }
  /**
   * This will update the organisation details
   *
   * @param {string} orgId
   * @param {object} obj
   */
  static updateOrg({ orgId, obj }) {
    return this.patch(`${config.baseUrlForUserOrg}/updateOrg/${orgId}/`, obj);
  }
  /**
   * This updates the user details
   *
   * @param {string} userId
   * @param {object} updateObj
   */
  static updateUser({ userId, updateObj }) {
    return this.patch(
      config.baseUrlForUserOrg + '/updateUser/' + userId,
      updateObj
    );
  }
  /**
   * Used to create new organisation
   *
   * @param {object} createObj
   */
  static createOrg(createObj) {
    return this.post(`${config.baseUrlForUserOrg}/createOrg/`, createObj);
  }
  /**
   * Used to get user organisation details
   *
   * @param {object} orgId
   */
  static getUserOrg(orgId) {
    return this.get(`${config.baseUrlForUserOrg}/organisation/${orgId}/`);
  }
  /**
   * Return user's information
   *
   * @param {string} type
   */
  static getUserInfo(type, { orgId, params = {} } = {}) {
    let url = `${config.baseUrlForUserOrg}/${type}`;
    if (orgId) {
      url = `${url}/${orgId}`;
    }
    if (params) {
      url += '?' + objectToQueryParams(params);
    }
    return this.get(url);
  }
  /**
   * To create new role
   *
   * @param {object} createObj
   */
  static createRole(createObj) {
    return this.post(`${config.baseUrlForUserOrg}/createRole`, createObj);
  }
  /**
   * To change the state of MFA (Multi factor authentication)
   *
   * @param {string} userId
   * @param {string} type
   */
  static changeMFAState({ userId, type }) {
    return this.post(`${config.baseUrlForUserOrg}/user/${userId}/${type}/mfa`);
  }
  /**
   * To update the role of a user
   *
   * @param {string} roleName
   * @param {object} updateObj
   */
  static updateRole(roleName, updateObj) {
    return this.patch(
      `${config.baseUrlForUserOrg}/updateRole/${roleName}`,
      updateObj
    );
  }

  /**
   * To create a user
   *
   * @param {object} userObj
   */
  static createUser(userObj) {
    return this.post(config.baseUrlForUserOrg + '/createUser/', userObj);
  }

  /**
   * To get user details
   *
   * @param {string} userId
   */
  static userDetails(userId) {
    return this.get(`${config.baseUrlForUserOrg}/fullUser/${userId}`);
  }
  // To get active roles
  static getActiveRoles() {
    return this.get(`${config.baseUrlForUserOrg}/activeRoles`);
  }
  /**
   * To get user truncated details
   *
   * @param {string} userId
   */
  static userTruncatedDetails(userId) {
    return this.get(`${config.baseUrlForUserOrg}/user/${userId}`);
  }

  /**
   * To get user map
   *
   * @param {Array<String>} userIdList
   */
  static userDetailMap(userIdList) {
    return this.post(`${config.baseUrlForUserOrg}/userDetails`, {
      users: userIdList
    });
  }

  /**
   * To get user's session
   *
   * @param {string} userId
   */
  static getUserSessions(userId) {
    return this.get(`${config.baseUrlForUserOrg}/user/${userId}/sessions`);
  }

  /**
   * To delete session
   *
   * @param {string} userId
   * @param {string} sessionId
   *
   */
  static deleteSession(userId, sessionId) {
    return this.delete(
      `${config.baseUrlForUserOrg}/user/${userId}/session/${sessionId}`
    );
  }

  /**
   * To delete multiple sessions
   *
   * @param {string} userId
   * @param {object} params
   */
  static deleteSessions(userId, { params = {} } = {}) {
    let url = `${config.baseUrlForUserOrg}/user/${userId}/logout`;
    if (params) {
      url += '?' + objectToQueryParams(params);
    }
    return this.delete(url);
  }
  /**
   * To generate password
   *
   * @param {string} userId
   */
  static generatePassword(userId) {
    return this.post(
      `${config.baseUrlForUserOrg}/generate/temporaryPassword/${userId}`
    );
  }

  /**
   *
   * @param {String} orgId
   */
  static getOnbardingStatus(orgId) {
    return this.get(`${config.baseUrlForUserOrg}/organisation/${orgId}/status`);
  }
  /**
   *
   * @param {String} orgId
   * @param {String} onboardingStatus
   */
  static setOnboardingStatus(orgId = store.state.orgId, onboardingStatus) {
    return this.patch(
      `${config.baseUrlForUserOrg}/organisation/${orgId}/status/${onboardingStatus}`
    );
  }
  static getActiveDiscoveryProjectsCount() {
    const currentOrg = store.state.currentlySelectedOrgId;
    return this.get(
      `${config.baseUrlForUserOrg}/user/discovery/count/${currentOrg}`
    );
  }
  static updateOrgSSOGroup(isSSOEnabled,orgId) {
    return this.get(`${config.baseUrlForUserOrg}/update/group/${orgId}?isSSOEnabled=${isSSOEnabled.toString()}`);
  }
}
